import { useMutation, useQuery } from '@tanstack/react-query';
import useTranslate from '../../Hooks/useTranslate';
import notify from '../../Style-guide/ToastMessage';
import { deleteData, getData, sendData, updateData } from '../fetchers';

export const useGetAllCourtsQuery = (params) =>
  useQuery({
    queryKey: ['courts', params?.params],
    queryFn: () => getData('courts', params?.params),
    select: (data) => data?.data,
    retry: 1,
    ...params,
  });

export const useGetCourtSettingsQuery = (params) =>
  useQuery({
    queryKey: ['court-settings', params?.params],
    queryFn: () => getData('courts/settings/:id', params?.params),
    select: (data) => data?.data,
    ...params,
  });

export const useUpdateCourtMutation = () => {
  const tr = useTranslate();

  return useMutation({
    mutationFn: ({ data, params, queryParams }) =>
      updateData('courts/:id', data, params, queryParams),
    onSuccess: (data) => notify.success(tr(data?.translationKey) || data?.message),
  });
};

export const useGetRelatedCourtsQuery = (params) =>
  useQuery({
    queryKey: ['related-courts', params?.params],
    queryFn: () => getData('courts/related-courts', params?.params),
    select: (data) => data?.data,
    retry: 1,
    ...params,
  });

export const useAddCourtToOrganizerMutation = () =>
  useMutation({
    mutationFn: ({ data, params, queryParams }) =>
      sendData('courts/add', data, params, queryParams),
    onSuccess: (data) => notify.success(data?.message),
  });

export const useDeleteCourtMutation = () =>
  useMutation({
    mutationFn: ({ data, params, queryParams }) =>
      deleteData('courts', data, params, queryParams),
    onSuccess: (data) => notify.success(data?.message),
  });
